import { render } from "./GeolocationScene.vue?vue&type=template&id=33223e73&scoped=true"
import script from "./GeolocationScene.vue?vue&type=script&lang=js"
export * from "./GeolocationScene.vue?vue&type=script&lang=js"

import "./GeolocationScene.vue?vue&type=style&index=0&id=33223e73&scoped=true&lang=css"

import exportComponent from "C:\\sw\\ar-unity-renderer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33223e73"]])

export default __exports__